export const SET_HRES6DE_INDEX = 'SET_HRES6DE_INDEX'
export const GET_HRES6DE_INDEX = 'GET_HRES6DE_INDEX'
export const RECEIVED_HRES6DE_INDEX = 'RECEIVED_HRES6DE_INDEX'



// WEBPACK FOOTER //
// ./src/store/modules/hres6de/mutation-types.js